import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NewShop from './views/NewShop.vue'
import NewShopWeb from './views/NewShopWeb.vue'
import NewShopNoWebhookChat from './views/NewShopNoWebhookChat.vue'
import NewShopNoWebhookBot from './views/NewShopNoWebhookBot.vue'
import NewShopNoOA from './views/NewShopNoOA.vue'
import OldShop from './views/OldShop.vue'
import OldShopOA from './views/OldShopOA.vue'
import Retail from './views/Retail.vue'
import RetailNoOA from './views/RetailNoOA.vue'

Vue.use(Router)

// export default new Router({

let root = Home;

// console.log('HiHIHi the route checking ' + GLOBAL_TABS);

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { auth: true },
      component: root
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/new-shop-web',
      name: 'NewShopWeb',
      meta: { auth: true },
      component: NewShopWeb
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/new-shop',
      name: 'NewShop',
      meta: { auth: true },
      component: NewShop
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/new-shop-bot',
      name: 'NewShopNoWebhookBot',
      meta: { auth: true },
      component: NewShopNoWebhookBot
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/new-shop-chat',
      name: 'NewShopNoWebhookChat',
      meta: { auth: true },
      component: NewShopNoWebhookChat
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/new-shop-no-oa',
      name: 'NewShopNoOA',
      meta: { auth: true },
      component: NewShopNoOA
    },
    {
      path: '/old-shop',
      name: 'OldShop',
      meta: { auth: true },
      component: OldShop
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/old-shop-oa',
      name: 'OldShopOA',
      meta: { auth: true },
      component: OldShopOA
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/retail',
      name: 'Retail',
      meta: { auth: true },
      component: Retail
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    },
    {
      path: '/retail-no-oa',
      name: 'RetailNoOA',
      meta: { auth: true },
      component: RetailNoOA
      // component: (GLOBAL_TABS === 'tdos' ? Togo : Home)
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   // const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
//   // if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

//   if (!to.query.p) {
//     to.query.p = process.env.VUE_APP_DEFAULT_PORTAL; // default portal
//     next({ path: to.path, query: to.query });
//   } else {
//     next();
//   }


// });

export default router;